import { render, staticRenderFns } from "./Velocimetro.vue?vue&type=template&id=6098452e&"
import script from "./Velocimetro.vue?vue&type=script&lang=js&"
export * from "./Velocimetro.vue?vue&type=script&lang=js&"
import style0 from "./Velocimetro.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports